import { getImage } from "../../services/image-utils";
import { Button } from "antd";
import "./home.scss";
import { Link } from "react-router-dom";

export default function Home() {
  const heroImage = getImage("/assets/Classbit-home-hero.jpeg");
  const associationLogo = getImage("/assets/SEABC_Logo.png");
  const styles = { backgroundImage: `url(${heroImage})` };
  return (
    <div style={styles} className="bg-home-hero text-center">
      <img
        src={associationLogo}
        className="inline h-32"
        title="Structural Engineers Association Brithis Columbia"
        alt="Association Logo"
      />
      <h1 className="text-5xl font-bold mt-8 mb-3 text-white">
        CERTIFICATE PROGRAM
      </h1>
      <h2 className="text-3xl mb-11 mt-0 text-white">Structural Engineering</h2>
      <Link to={"/SEABC/courses"}>
        <Button className="h-fit text-base py-3 px-6 font-bold " type="primary">
          View Courses
        </Button>
      </Link>

      <p className="text-base text-white">
        Take me back to the
        <Button
          className="mt-4 text-base"
          href="https://www.seabc.ca/"
          type="link"
        >
          {" "}
          SEABC Website
        </Button>
      </p>
    </div>
  );
}
